import axios from 'axios';

import {
  MedicaoPressaoArterialAlterarFormData,
  MedicaoPressaoArterialCriarFormData,
  MedicaoPressaoArterialExcluirFormData,
  MedicoesQueryObj,
  ResponseObj,
} from '../../../back/src/types';
import { MedicaoPressaoArterial } from '../../../back/src/entity/MedicaoPressaoArterial';

const buscaMedicoes = async (
  pacienteId: number,
  queryObj?: MedicoesQueryObj,
): Promise<ResponseObj<MedicaoPressaoArterial[]>> => {
  const res = await axios.get<ResponseObj<MedicaoPressaoArterial[]>>(
    `medicoes_pressao_arterial/${pacienteId}`,
    { params: queryObj },
  );
  return res.data;
};

const criaMedicao = async (
  formData: MedicaoPressaoArterialCriarFormData,
): Promise<ResponseObj<MedicaoPressaoArterial>> => {
  const res = await axios.post<ResponseObj<MedicaoPressaoArterial>>('medicoes_pressao_arterial', formData);
  return res.data;
};

const alteraMedicao = async (
  medicaoId: number,
  formData: MedicaoPressaoArterialAlterarFormData,
): Promise<ResponseObj<MedicaoPressaoArterial>> => {
  const res = await axios.put<ResponseObj<MedicaoPressaoArterial>>(`medicoes_pressao_arterial/${medicaoId}`, formData);
  return res.data;
};

const excluiMedicao = async (
  medicaoId: number,
  formData: MedicaoPressaoArterialExcluirFormData,
): Promise<ResponseObj<MedicaoPressaoArterial>> => {
  const res = await axios.post<ResponseObj<MedicaoPressaoArterial>>(`medicoes_pressao_arterial/${medicaoId}/excluir`, formData);
  return res.data;
};

export default {
  buscaMedicoes,
  criaMedicao,
  alteraMedicao,
  excluiMedicao,
};
